import { HumanProcessingStatus } from "@dune/types";
import { Chip } from "@dune/ui";
import { ColumnDef } from "@tanstack/react-table";
import { FileIcon, Loader2 } from "lucide-react";

export type FilesColumnsOptions = {
	loadingFileKey: string | null;
};

export type FilesAnalyze = {
	file: {
		id: string;
		name: string;
		key: string;
		mimeType: string;
		bucket: string;
		humanProcessingStatus: HumanProcessingStatus;
	};
	type: string;
};

export const filesColumns = ({
	loadingFileKey,
}: FilesColumnsOptions): ColumnDef<FilesAnalyze>[] => [
	{
		accessorKey: "file.name",
		header: "Nom",
		cell: ({ row }) => {
			const file = row.original.file;
			const isLoading = loadingFileKey === file.key;
			return (
				<div className="flex items-center gap-2 min-w-0 w-full">
					{isLoading ? (
						<Loader2 size={16} className="animate-spin flex-shrink-0" />
					) : (
						<FileIcon size={16} className="flex-shrink-0" />
					)}
					<span className="truncate flex-1 text-left" title={file.name}>
						{file.name}
					</span>
				</div>
			);
		},
	},
	{
		accessorKey: "status",
		header: "Statut",
		cell: ({ row }) => {
			const { file } = row.original;

			return (
				<div className="min-w-0">
					{file.humanProcessingStatus === "TO_BE_PROCESSED" && (
						<Chip variant="bordered" color="orange" label="À traiter" />
					)}
					{file.humanProcessingStatus === "COMPLIANT" && (
						<Chip variant="bordered" color="green" label="Conforme" />
					)}
					{file.humanProcessingStatus === "NON_COMPLIANT" && (
						<Chip variant="bordered" color="red" label="Non Conforme" />
					)}
				</div>
			);
		},
	},
];
